module.exports = __webpack_public_path__ + "img/132.aea26e29.jpg";